import React, { useMemo } from "react";

import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import FormHelperText from "@mui/material/FormHelperText";
import { LocationSuggestion, ZipCodeSuggestion } from "../../types/fieldTypes";
import { debounce } from "@mui/material";

const styles = {
  autocomplete: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "6px",
      background: "#f8f9fd !important;",
    },
  },
};

export default function CustomAutoComplete(props: any) {
  const {
    options,
    selectedValue,
    getOptionLabels,
    onChange,
    errorMsg,
    childIdx,
    isApplicationSubmitted,
    onBlur,
    label,
    field,
    translation,
    loanContextData,
    isExpandedView,
    onInputChange,
    inputValue,
    subComponentLabel,
    component,
    unitIdx,
  } = props;

  const debouncedOnInputChange = useMemo(
    () =>
      debounce((event, value) => {
        onInputChange(
          event,
          value,
          translation,
          loanContextData,
          childIdx,
          field,
          ["Address", "Borrower/Guarantors Address"].includes(label)
        );
      }, 100),
    [translation, loanContextData, childIdx, field, label],
  );

  return (
    <FormControl
      variant="outlined"
      sx={isExpandedView ? { width: "100%" } : { width: "80%" }}
    >
      <Autocomplete
        className="truncate-words"
        options={options ?? []}
        size="small"
        filterOptions={(x: any) => x}
        filterSelectedOptions
        disableClearable
        isOptionEqualToValue={(opt, val) => opt?.city === val?.city}
        value={selectedValue ?? null}
        inputValue={inputValue ?? ""}
        getOptionLabel={getOptionLabels}
        disabled={isApplicationSubmitted}
        onChange={(
          event: React.SyntheticEvent<Element, Event>,
          newValue: LocationSuggestion | ZipCodeSuggestion | null,
        ) => {
          if (["Borrower/Guarantors Address"].includes(label)) {
            onChange(
              newValue,
              field,
              subComponentLabel,
              translation,
              loanContextData,
              component,
              childIdx,
              unitIdx,
            );
          } else {
            onChange(
              event,
              newValue,
              childIdx,
              field,
              translation,
              loanContextData,
            );
          }
        }}
        onInputChange={debouncedOnInputChange}
        onBlur={onBlur}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            value={selectedValue ?? ""}
            margin="dense"
            className={`${!!errorMsg && "app-theme-data-points-error"}`}
            style={
              isExpandedView
                ? { width: "calc(100% - 2px)" }
                : {
                    width: "100%",
                  }
            }
            variant="outlined"
            disabled={isApplicationSubmitted}
            sx={
              (styles.autocomplete,
              { borderRadius: "6px", background: "#f8f9fd !important;" })
            }
          />
        )}
        selectOnFocus
      />
      <FormHelperText className="break-word">{errorMsg}</FormHelperText>
    </FormControl>
  );
}
